import { memo } from 'react';

function AnalysisSpeedometerIcon({ color }: { color: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" viewBox="0 0 18 19">
      <g stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" clipPath="url(#clip0_588_5372)">
        <path d="M9 5.758l.008-.009M12 7.258l.008-.009M6 7.258l.008-.009M13.5 10.258l.008-.009M4.5 10.258l.008-.009M12.75 13.258l.008-.009M5.25 13.258l.008-.009M9 13.25l.75-4.5M6.375 15.5H3a7.5 7.5 0 1112 0h-3.375"></path>
        <path d="M9 17.75a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"></path>
      </g>
      <defs>
        <clipPath id="clip0_588_5372">
          <path fill="#fff" d="M0 0H18V18H0z" transform="translate(0 .5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(AnalysisSpeedometerIcon);
